module.exports = __webpack_public_path__ + "img/r1.3c9c82c7.jpg";